import request from '@/utils/request';
import { BASE_URL } from '@/utils/global';

// 查询角色列表
export function getRoleList(data: any, params: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/account/role/queryList.ac`,
    method: 'post',
    params,
    data,
  });
}

// 获取权限列表
export function getMenu() {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/account/menu/list.ac`,
    method: 'post',
  });
}

// 新增角色
export function addRole(data: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/account/role/add.ac`,
    method: 'post',
    data,
  });
}

// 更新角色
export function updateRole(data: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/account/role/update.ac`,
    method: 'post',
    data,
  });
}

// 删除角色
export function deleteRole(data: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/account/role/delete.ac`,
    method: 'post',
    data,
  });
}

// 获取角色详情
export function getRole(data: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/account/role/get.ac`,
    method: 'post',
    data,
  });
}
